import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "button"]
  static values = {
    type: String,
    page: { type: Number, default: 1 },
    max: { type: Number, default: 1 },
    loading: { type: String, default: 'Cargando...' },
    load: { type: String, default: 'Cargar más' }
  }

  connect() {
    // Fallback to IDs if targets not set (backwards compat)
    if (!this.hasContainerTarget) this._container = document.getElementById('ajax-posts')
    else this._container = this.containerTarget

    if (!this.hasButtonTarget) this._button = document.getElementById('load-more')
    else this._button = this.buttonTarget

    if (!this._button) return

    this._isLoading = false
    this._activeFilters = ''
    this._currentPage = this.pageValue
    this._maxPages = this.maxValue
    this._currentLanguage = document.documentElement.lang

    this._button.addEventListener('click', () => this.loadMore())

    // Back-button state restoration
    this._container?.addEventListener('click', (e) => {
      if (e.target.closest('a')) {
        sessionStorage.setItem('art_from_listing', '1')
      }
    })

    // Filter integration
    document.addEventListener('cal:filters-changed', (e) => {
      const { qs, maxPages } = e.detail || {}
      this._activeFilters = qs || ''
      this._currentPage = 1
      this._maxPages = parseInt(maxPages || this._maxPages)
      if (this._button) this._button.style.display = this._maxPages > 1 ? '' : 'none'
    })

    this._loadSavedPosts()
  }

  async loadMore(replace = false) {
    if (this._isLoading || this._currentPage >= this._maxPages) return

    this._isLoading = true
    this._button.textContent = this.loadingValue

    const prevCount = this._container.children.length

    try {
      const qs = `action=load_more_posts&page=${this._currentPage + 1}&type=${this.typeValue}` +
        (this._activeFilters ? `&${this._activeFilters}` : '')
      const response = await fetch(art.ajaxurl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: qs,
      })
      if (!response.ok) throw new Error('Network error')
      const data = await response.json()

      if (data.success) {
        this._container.insertAdjacentHTML('beforeend', data.data.html)

        Array.from(this._container.children).slice(prevCount).forEach(item =>
          item.classList.add('fade-up'))

        this._currentPage++
        this._maxPages = parseInt(data.data.max_pages) || this._maxPages

        this._saveState()

        this._button.style.display = this._currentPage >= this._maxPages ? 'none' : ''
      }
    } catch (error) {
      console.error('Error loading more posts:', error)
    } finally {
      this._isLoading = false
      this._button.textContent = this.loadValue
    }
  }

  _saveState() {
    sessionStorage.setItem('savedPosts', this._container.innerHTML)
    sessionStorage.setItem('savedPage', this._currentPage)
    sessionStorage.setItem('savedMaxPages', this._maxPages)
    sessionStorage.setItem('savedLanguage', this._currentLanguage)
    sessionStorage.setItem('savePath', window.location.pathname)
    sessionStorage.setItem('savedType', this.typeValue)
    sessionStorage.setItem('savedFilters', this._activeFilters)
  }

  _loadSavedPosts() {
    const savedType = sessionStorage.getItem('savedType')
    const savedPath = sessionStorage.getItem('savePath')
    const fromListing = sessionStorage.getItem('art_from_listing')
    sessionStorage.removeItem('art_from_listing')

    if (!fromListing || savedType !== this.typeValue || savedPath !== window.location.pathname) {
      this._clearState()
      return
    }

    const savedPosts = sessionStorage.getItem('savedPosts')
    const savedPage = sessionStorage.getItem('savedPage')
    const savedMaxPages = sessionStorage.getItem('savedMaxPages')
    const savedLanguage = sessionStorage.getItem('savedLanguage')
    const savedFilters = sessionStorage.getItem('savedFilters') || ''

    if (savedPosts && savedPage && savedLanguage) {
      this._container.innerHTML = savedPosts
      this._currentPage = parseInt(savedPage)
      this._activeFilters = savedFilters
      if (savedMaxPages) this._maxPages = parseInt(savedMaxPages)
      this._button.style.display = this._currentPage >= this._maxPages ? 'none' : ''
    }
  }

  _clearState() {
    sessionStorage.removeItem('savedPosts')
    sessionStorage.removeItem('savedPage')
    sessionStorage.removeItem('savedMaxPages')
    sessionStorage.removeItem('savedLanguage')
    sessionStorage.removeItem('savePath')
    sessionStorage.removeItem('savedType')
    sessionStorage.removeItem('savedFilters')
  }
}
